// @ts-ignore
// Английский
import en from './en.json';
// @ts-ignore
// Русский
import ru from './ru.json';
// @ts-ignore
// Армянский
import am from './am.json';
// @ts-ignore
// Узбекский
import uz from './uz.json';
// @ts-ignore
// Азербайджанский
import az from './az.json';
// @ts-ignore
// Киргизский
import ky from './ky.json';
// @ts-ignore
// Таджикский
import tg from './tg.json';

export const SYSTEM_LANGUAGES = { RU: ru, EN: en, AM: am, UZ: uz, TG: tg, KY: ky, AZ: az };
